import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.access-control-policy', {
        url: '/access-control-policy',
        component: 'companyManageApplicationAccessControlPolicy',
        resolve: {authenticationAccessPolicyList},
    });
}

/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    const type='basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId,type);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.state.js